import React, { CSSProperties, ReactNode, useState } from "react";
import Gutter from "../Gutter";
import { Container } from "../Layout";
import { Typography } from "../Typography";
import Colors from "ui-kit/colors";
import { FlexRow } from "ui-kit/Layout/Flex";
import { Icon, type Glyph } from "@/ui-kit";
import classNames from "classnames";
import styles from "./Panel.module.css";

const VariantStyles: Record<
  string,
  {
    iconName: Glyph;
    iconColor: Colors;
    borderColor: Colors;
    background: Colors;
  }
> = {
  disclaimer: {
    iconName: "information-circle",
    iconColor: Colors.sun500,
    borderColor: Colors.sun500,
    background: Colors.sun100,
  },
  info: {
    iconName: "information-circle",
    iconColor: Colors.blue300,
    borderColor: Colors.navy100,
    background: Colors.navy100,
  },
  success: {
    iconName: "checkmark-circle",
    iconColor: Colors.forrest500,
    borderColor: Colors.forrest300,
    background: Colors.forrest100,
  },
  error: {
    iconName: "error-circle",
    iconColor: Colors.red500,
    borderColor: Colors.red300,
    background: Colors.red100,
  },
};

type InfomationPanelProps = {
  children: ReactNode | ReactNode[];
  variant: "disclaimer" | "info" | "success" | "error";
  title?: string;
  style?: CSSProperties;
  expandable?: boolean;
};

export const Panel = ({
  title,
  variant = "disclaimer",
  children,
  style: containerStyle,
  expandable = false,
}: InfomationPanelProps) => {
  const [open, setOpen] = useState(!expandable);

  return (
    <div
      {...(expandable
        ? { onClick: () => setOpen(!open), style: { cursor: "pointer" } }
        : {})}
    >
      <Container
        border
        style={{
          borderColor: VariantStyles[variant].borderColor,
          background: VariantStyles[variant].background,
          ...containerStyle,
        }}
      >
        {title && (
          <FlexRow alignItems="center">
            <Icon
              name={VariantStyles[variant].iconName}
              size="M"
              color={VariantStyles[variant].iconColor}
              className={styles.icon}
            />

            <Gutter size={2} horizontal />
            <Typography>
              <strong>{title}</strong>
            </Typography>
            <Gutter size={2} horizontal />
            {expandable && (
              <Icon
                name={open ? "chevron-up" : "chevron-down"}
                size="M"
                color={Colors.grey500}
                className={styles.arrow}
              />
            )}
          </FlexRow>
        )}
        <div className={classNames(styles.content, open && styles.open)}>
          <Gutter size={1} />
          {children}
        </div>
      </Container>
    </div>
  );
};
